/* Master PDP behaviour (Welcome Offer buy box + master ATF layout).
   Vanilla JS, no dependencies. Safe to load on any template: every hook is
   feature-detected off [data-master-buybox] / .pdp-master-atf. */
(function () {
  'use strict';

  /* Plan gallery: a pdp_plan row can carry its own images (gallery_override).
     They are rendered ahead of the product's own media and tagged with the
     plan's supply length; only the selected plan's set is visible. See
     snippets/mpdp-plan-gallery.liquid.

     Nothing is spliced. A hidden flex child collapses to zero width, so the
     first VISIBLE slide sits at scroll offset 0 on the desktop strip, and
     swipe-group.js rebuilds its slide list on every call filtering out
     anything with display:none — both galleries follow `hidden` on their own.

     Returns null when this product has no plan images at all, so a product
     without them behaves exactly as it did before. */
  function createPlanGallery() {
    var root = document.querySelector('.pdp-master-atf');
    if (!root) return null;
    var tagged = Array.prototype.slice.call(root.querySelectorAll('[data-mpdp-plan-gallery]'));
    if (!tagged.length) return null;

    var strip = root.querySelector('.product-slideshow__items');
    var desktopSlides = Array.prototype.slice.call(
      root.querySelectorAll('.product-slideshow__item--desktop')
    );
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.js-product-slideshow-thumb'));

    var abEnabled = root.hasAttribute('data-mpdp-ab-test');
    var abFallbackUrl = root.getAttribute('data-mpdp-ab-first-image');
    var appliedPlan = false;
    var fallbackApplied = false;
    var fallbackImages = [];
    if (abFallbackUrl) {
      var baseSlides = [
        desktopSlides.filter(function (slide) { return !slide.hasAttribute('data-mpdp-plan-gallery'); })[0],
        Array.prototype.slice.call(root.querySelectorAll('.product-slideshow__item--mobile')).filter(function (slide) {
          return !slide.hasAttribute('data-mpdp-plan-gallery');
        })[0]
      ].filter(Boolean);
      var baseIds = baseSlides.map(function (slide) { return slide.getAttribute('data-media-id'); });
      var baseNodes = baseSlides.concat(thumbs.filter(function (thumb) {
        return baseIds.indexOf(thumb.getAttribute('data-media-target-id')) !== -1;
      }));
      baseNodes.forEach(function (node) {
        node.querySelectorAll('img').forEach(function (img) {
          var attributes = {};
          ['src', 'srcset', 'data-defer-src', 'data-defer-srcset', 'data-gallery-deferred'].forEach(function (name) {
            attributes[name] = img.getAttribute(name);
          });
          fallbackImages.push({ image: img, attributes: attributes });
        });
      });
    }

    /* Which set the server painted. Starting from the DOM rather than from a
       guess means the common case — the buy box agreeing with the plan row's
       is_default — costs nothing at init and leaves the loaded markup alone. */
    var currentMonths = '';
    tagged.some(function (el) {
      if (el.hidden) return false;
      currentMonths = el.getAttribute('data-mpdp-plan-gallery') || '';
      return true;
    });

    /* A revealed slide still holds the 1x1 placeholder its src was swapped
       for; the theme only promotes a deferred image on scroll or a thumb
       click, so nothing else would load it on a plan change. */
    function hydrate(node) {
      node.querySelectorAll('img[data-defer-src]').forEach(function (img) {
        var src = img.getAttribute('data-defer-src');
        if (!src || img.getAttribute('src') === src) return;
        var srcset = img.getAttribute('data-defer-srcset');
        if (srcset && !img.getAttribute('srcset')) img.setAttribute('srcset', srcset);
        img.setAttribute('src', src);
        img.removeAttribute('data-defer-src');
        img.removeAttribute('data-defer-srcset');
        img.removeAttribute('data-gallery-deferred');
      });
    }

    /* `force` is what a card CLICK passes. Without it the shortcut below would
       swallow two cases the customer would notice: two cards resolving to the
       same supply length (the plan rows are keyed by months, so they share an
       image set), and anyone who has clicked off to thumbnail 7 and then picks
       a plan — choosing a plan always brings them back to image 1. The init
       reconcile passes no flag, so a page that already agrees with the server
       leaves the rendered markup untouched. */
    return function applyPlan(months, force) {
      var key = months == null ? '' : String(months);
      if (!force && key === currentMonths && (!abEnabled || appliedPlan)) return;
      appliedPlan = true;
      currentMonths = key;

      tagged.forEach(function (el) {
        var mine = el.getAttribute('data-mpdp-plan-gallery') === key;
        el.hidden = !mine;
        if (mine) hydrate(el);
      });

      var useFallback = !!abFallbackUrl && !tagged.some(function (el) { return !el.hidden; });
      if (useFallback !== fallbackApplied) {
        fallbackImages.forEach(function (saved) {
          Object.keys(saved.attributes).forEach(function (name) {
            var value = useFallback ? (name === 'src' ? abFallbackUrl : null) : saved.attributes[name];
            if (value === null) saved.image.removeAttribute(name);
            else saved.image.setAttribute(name, value);
          });
        });
        fallbackApplied = useFallback;
      }

      /* Show the new first image. On desktop that means moving the theme's own
         active-slide marker — but scoped to the desktop slides only. The
         theme's setActiveMedia hides EVERY slide including the mobile ones,
         which would empty the mobile strip for anyone who then resizes. */
      var active = null;
      desktopSlides.forEach(function (slide) {
        if (!active && !slide.hidden) {
          active = slide;
          return;
        }
        slide.classList.remove('d-block');
        slide.classList.add('d-none');
      });
      if (active) {
        active.classList.remove('d-none');
        active.classList.add('d-block');
        hydrate(active);
        var target = active.getAttribute('data-media-id');
        thumbs.forEach(function (thumb) {
          var isActive = !thumb.hidden && thumb.getAttribute('data-media-target-id') === target;
          thumb.classList.toggle('is-active-item', isActive);
        });
      }

      /* Mobile: back to the start of the strip, then let swipe-group.js
         recount its dots and counter — it listens for `scroll` on the strip and
         exposes nothing else, and a scroll that does not move fires no event of
         its own.

         Twice, and instantly. The strip is `scroll-snap-type: x mandatory` with
         `scroll-behavior: smooth`, so (a) `behavior: 'auto'` resolves to that
         smooth scroll, and (b) revealing slides at the FRONT makes the browser
         re-snap to hold the previously snapped slide in place — adding the
         inserted width back on at the next layout, which is after our scroll
         has been issued. One pass alone left the customer two slides past the
         image they had just chosen. The second pass runs once that re-snap has
         had its go, and doubles as a second chance for the recount. */
      if (strip) {
        var resetStrip = function () {
          strip.scrollTo({ left: 0, behavior: 'instant' });
          strip.dispatchEvent(new Event('scroll'));
        };
        resetStrip();
        window.requestAnimationFrame(resetStrip);
      }
    };
  }

  /* Fit the name and localized price together at the same font size.
     Measure again after fonts load and whenever this buy box resizes,
     including narrow advertorial columns and cards revealed after page load. */
  function initPlanHeadSizing(widget) {
    var heads = Array.prototype.slice.call(widget.querySelectorAll('.master-buybox__plan-head'));
    if (!heads.length) return;
    var frame = 0;
    function fit() {
      frame = 0;
      heads.forEach(function (head) {
        var label = head.querySelector('.master-buybox__plan-label');
        if (!label || !head.getBoundingClientRect().width) return;
        head.classList.remove('is-compact');
        head.style.removeProperty('--master-plan-font-size');
        var baseSize = parseFloat(getComputedStyle(label).fontSize);
        var range = document.createRange();
        range.selectNodeContents(label);
        function fits() {
          return range.getBoundingClientRect().width <= label.getBoundingClientRect().width + 0.1;
        }
        function fittedSize() {
          head.style.setProperty('--master-plan-font-size', baseSize + 'px');
          if (fits()) return baseSize;
          var low = 1;
          var high = baseSize;
          for (var i = 0; i < 9; i++) {
            var size = (low + high) / 2;
            head.style.setProperty('--master-plan-font-size', size + 'px');
            if (fits()) low = size;
            else high = size;
          }
          return Math.floor(low * 10) / 10;
        }
        var size = fittedSize();
        if (size < 11.5) {
          head.classList.add('is-compact');
          size = fittedSize();
        }
        head.style.setProperty('--master-plan-font-size', size + 'px');
      });
    }
    function requestFit() {
      if (!frame) frame = window.requestAnimationFrame(fit);
    }
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(function () {
        if (!widget.isConnected) { observer.disconnect(); return; }
        requestFit();
      });
      heads.forEach(function (head) { observer.observe(head); });
    }
    window.addEventListener('resize', requestFit);
    if (document.fonts) document.fonts.ready.then(requestFit);
    widget.addEventListener('master:plan-changed', requestFit);
    requestFit();
  }

  function initBuybox(widget) {
    if (widget.dataset.masterInit === 'true') return;
    widget.dataset.masterInit = 'true';
    initPlanHeadSizing(widget);

    var plans = Array.prototype.slice.call(widget.querySelectorAll('[data-master-plan]'));
    var variantInput = widget.querySelector('[data-master-variant-input]');
    var sellingPlanInput = widget.querySelector('[data-master-selling-plan-input]');
    var giftPlanInput = widget.querySelector('[data-master-gift-plan-input]');
    var atcPrice = widget.querySelector('[data-master-atc-price]');
    var planGallery = createPlanGallery();

    /* Selecting a plan collapses the previously selected card's benefits and
       gift kit and opens the new card's. On mobile the cards stack, so a
       customer who has scrolled down the tall 3-month card and taps 1-month
       beneath it watches the page reflow around them: the card opens but the
       frame is half off-screen. On every user-made selection, put the buy
       box's top just under the header so the whole frame reads from the top.
       On desktop the sticky sidebar already sits there, so the move is nil. */
    function keepBuyboxInView() {
      var stickyTop = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--mpdp-sticky-top')
      );
      if (isNaN(stickyTop)) stickyTop = 56;
      var gap = 12;
      var target = Math.max(0, window.scrollY + widget.getBoundingClientRect().top - stickyTop - gap);
      if (Math.abs(target - window.scrollY) < 1) return;
      window.scrollTo({ top: target, behavior: 'smooth' });
    }

    function selectPlan(plan, fromUser) {
      plans.forEach(function (p) {
        var selected = p === plan;
        p.classList.toggle('is-selected', selected);
        p.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (variantInput && plan.dataset.variantId) {
        variantInput.value = plan.dataset.variantId;
      }
      if (sellingPlanInput) {
        var sellingPlan = plan.dataset.sellingPlan || '';
        sellingPlanInput.value = sellingPlan;
        sellingPlanInput.disabled = sellingPlan === '';
      }
      /* The gift-plan stamp follows the SELECTED card for the same reason the
         variant and selling plan inputs do: left on the previously selected
         plan, it would earn the customer the wrong plan's free gifts. */
      if (giftPlanInput) {
        giftPlanInput.value = plan.dataset.planMonths || '';
      }
      /* The button states what THIS option charges. Same source as the option's
         own displayed price, so the two cannot drift.

         An option with no price CLEARS the span rather than being skipped.
         Skipping left the previous option's price standing: selecting the
         one-time purchase switched the variant but the button carried on
         advertising the 6-month subscription's total. Stating no price is
         merely unhelpful; stating someone else's is wrong. */
      if (atcPrice) {
        var cardPrice = plan.dataset.atcPrice;
        atcPrice.textContent = cardPrice ? ' | ' + cardPrice : '';
      }
      /* This plan's own gallery images take the front of the gallery. The
         one-time button carries no data-plan-months, so selecting it clears
         them — which is what "another plan is selected" has to mean for the
         option that is not a plan. */
      if (planGallery) planGallery(plan.dataset.planMonths || '', true);
      /* Announce the new selection so satellites of the buy box — the sticky
         add-to-cart bar, which shows the same plan and the same price — follow
         it without reading .is-selected for themselves. One event, both
         directions: the sticky bar drives selection through masterSelectPlan
         below and listens here for selections made in the buy box itself. */
      widget.dispatchEvent(
        new CustomEvent('master:plan-changed', { bubbles: true, detail: { plan: plan } })
      );
      if (fromUser) keepBuyboxInView();
    }

    /* Exposed so the sticky bar can select a plan WITHOUT fromUser: passing
       true there runs keepBuyboxInView(), which smooth-scrolls the page up to
       the buy box — precisely what someone using the sticky bar is trying to
       avoid. */
    widget.masterSelectPlan = selectPlan;

    /* Reconcile once against whichever card is actually selected. The gallery
       renders the plan row that claims is_default, while the buy box picks its
       pre-selected card from a walk over the variant's live allocations — the
       two can disagree, and the DOM is the tiebreaker. */
    if (planGallery) {
      var preselected = plans.filter(function (p) {
        return p.classList.contains('is-selected');
      })[0];
      if (preselected) planGallery(preselected.dataset.planMonths || '');
    }

    plans.forEach(function (plan) {
      plan.addEventListener('click', function (event) {
        if (event.target.closest('.js-master-future')) return;
        selectPlan(plan, true);
      });
      plan.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Enter') {
          if (event.target.closest('.js-master-future')) return;
          event.preventDefault();
          selectPlan(plan, true);
        }
      });
    });

    widget.querySelectorAll('.js-master-future-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var wrap = toggle.closest('.js-master-future');
        var panel = wrap && wrap.querySelector('.js-master-future-panel');
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* Gallery progress bar: mirror the carousel counter into a width. */
  function initGalleryProgress(root) {
    root.querySelectorAll('.pdp-gallery-progress').forEach(function (bar) {
      var row = bar.closest('.pdp-gallery-dots-row') || root;
      var scope = bar.closest('sht-carousel') || root;
      var current = scope.querySelector('.js-carousel-counter-current');
      var total = scope.querySelector('.js-carousel-counter-total');
      var fill = bar.querySelector('.pdp-gallery-progress__fill');
      if (!fill) return;

      function sync() {
        var c = parseInt((current && current.textContent) || bar.dataset.current || '1', 10) || 1;
        var t = parseInt((total && total.textContent) || bar.dataset.total || '1', 10) || 1;
        fill.style.setProperty('width', Math.max(0, Math.min(100, (c / t) * 100)) + '%');
      }
      sync();
      /* Both counters, not just the current one. Selecting a plan changes how
         many slides the gallery HAS while the current slide stays 1, so
         watching only the current counter left the rail at the width it had
         for the previous plan's slide count. */
      [current, total].forEach(function (counter) {
        if (!counter) return;
        new MutationObserver(sync).observe(counter, {
          childList: true,
          characterData: true,
          subtree: true
        });
      });
      void row;
    });
  }

  /* dock-drop imperatively sets height/max-height !important on the media
     wrapper; under the master layout the gallery must size itself (square
     media). Strip the inline overrides whenever they reappear. */
  function neutralizeGalleryHeight(root) {
    var targets = root.querySelectorAll(
      '.product__media-wrapper, .product__media-wrapper--single-with-thumbnails'
    );
    targets.forEach(function (wrapper) {
      function strip() {
        if (wrapper.style.height || wrapper.style.maxHeight || wrapper.style.getPropertyValue('--dock-gallery-height')) {
          wrapper.style.removeProperty('height');
          wrapper.style.removeProperty('max-height');
          wrapper.style.removeProperty('--dock-gallery-height');
        }
      }
      strip();
      new MutationObserver(strip).observe(wrapper, { attributes: true, attributeFilter: ['style'] });
    });
  }

  /* Section nav: smooth-scroll to [data-anchor] targets and highlight the
     pill for the section currently in view. Anchor wrappers may be
     display:contents, so scroll to their first element child. */
  function anchorScrollTarget(key) {
    var wrap = document.querySelector('[data-anchor="' + key + '"]');
    if (!wrap) return null;
    return wrap.firstElementChild && getComputedStyle(wrap).display === 'contents'
      ? wrap.firstElementChild
      : wrap;
  }

  function initSectionNav(nav) {
    if (nav.dataset.mpdpInit === 'true') return;
    nav.dataset.mpdpInit = 'true';
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-anchor-target]'));
    var track = nav.querySelector('.mpdp-nav__track');

    /* scroll only the chip track horizontally to center the active chip.
       link.scrollIntoView() was used here before, but the track has no
       vertical overflow so the browser fell back to scrolling the whole
       document to satisfy the block axis too — fighting the window.scrollTo
       below and causing the page to jump/stutter on click. */
    function centerLink(link) {
      if (!track || !link) return;
      var trackRect = track.getBoundingClientRect();
      var linkRect = link.getBoundingClientRect();
      var offset = (linkRect.left + linkRect.width / 2) - (trackRect.left + trackRect.width / 2);
      track.scrollBy({ left: offset, behavior: 'smooth' });
    }

    function setActive(link) {
      links.forEach(function (l) { l.classList.toggle('is-active', l === link); });
      centerLink(link);
    }

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var target = anchorScrollTarget(link.dataset.anchorTarget);
        if (!target) return;
        setActive(link);
        var y = target.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    /* highlight the active chip while scrolling, and keep it in view within
       the track (chips further along the list would otherwise stay cut off).
       This used to run off an IntersectionObserver with a narrow rootMargin
       band, but during a long smooth-scroll (e.g. clicking the first chip
       while sat at the last one) several sections cross that band inside a
       single callback, and the entries in that callback aren't ordered by
       scroll position — they reflect target registration order — so the
       last one processed won regardless of which section was actually in
       view, making the highlight jump around instead of progressing in
       order. Recomputing the active link straight from each section's live
       position on every scroll frame removes that ambiguity. */
    var targets = links
      .map(function (link) {
        var target = anchorScrollTarget(link.dataset.anchorTarget);
        return target ? { link: link, target: target } : null;
      })
      .filter(Boolean);

    if (targets.length) {
      var scrollTicking = false;
      function syncActiveFromScroll() {
        scrollTicking = false;
        var line = window.innerHeight * 0.3;
        var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        var current = targets[0].link;
        for (var i = 0; i < targets.length; i++) {
          /* a section hidden by CSS (the Nox banner while it is switched off)
             has no box and would read as top 0, i.e. always passed */
          if (!targets[i].target.getClientRects().length) continue;
          if (atBottom || targets[i].target.getBoundingClientRect().top <= line) {
            current = targets[i].link;
          } else {
            break;
          }
        }
        setActive(current);
      }
      function requestActiveSync() {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(syncActiveFromScroll);
      }
      window.addEventListener('scroll', requestActiveSync, { passive: true });
      window.addEventListener('resize', requestActiveSync);
      syncActiveFromScroll();
    }
  }

  /* generic horizontal scroller with prev/next buttons */
  function initScrollCarousel(carousel) {
    if (carousel.dataset.mpdpInit === 'true') return;
    carousel.dataset.mpdpInit = 'true';
    var track = carousel.querySelector('[data-mpdp-carousel-track]');
    var prev = carousel.querySelector('[data-mpdp-carousel-prev]');
    var next = carousel.querySelector('[data-mpdp-carousel-next]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children);
    var shouldLoop = carousel.hasAttribute('data-mpdp-carousel-loop');
    var edgeTolerance = 2;
    var pendingTarget = null;

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    /* A bled scrollport (the people track runs to the viewport edges and hands
       the page margin back as inline padding) rests each card that margin in
       from its own left edge. Subtract it, or the arrows would park cards
       flush against the screen edge while card one sits on the margin. Zero
       for every other carousel, which carries no inline padding. */
    function leadingInset() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.paddingInlineStart || styles.paddingLeft) || 0;
    }

    function cardPositions() {
      var trackRect = track.getBoundingClientRect();
      var inset = leadingInset();
      return cards.map(function (card) {
        return card.getBoundingClientRect().left - trackRect.left + track.scrollLeft - inset;
      });
    }

    function scrollToPosition(left) {
      var target = Math.max(0, Math.min(maxScrollLeft(), left));
      pendingTarget = target;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        track.scrollLeft = target;
      }
    }

    function move(direction) {
      var maximum = maxScrollLeft();
      if (cards.length < 2 || maximum <= edgeTolerance) return;

      /* Keep advancing from the last requested destination while a smooth
         scroll is still moving. Some mobile browsers otherwise receive two
         quick taps at the same old scrollLeft and appear to ignore one. */
      var reference = pendingTarget === null ? track.scrollLeft : pendingTarget;
      var current = Math.max(0, Math.min(maximum, reference));
      var atStart = current <= edgeTolerance;
      var atEnd = current >= maximum - edgeTolerance;

      if (shouldLoop && ((direction < 0 && atStart) || (direction > 0 && atEnd))) {
        scrollToPosition(direction < 0 ? maximum : 0);
        return;
      }

      var positions = cardPositions();
      var target = null;
      if (direction > 0) {
        for (var i = 0; i < positions.length; i++) {
          if (positions[i] > current + edgeTolerance) {
            target = positions[i];
            break;
          }
        }
      } else {
        for (var j = positions.length - 1; j >= 0; j--) {
          if (positions[j] < current - edgeTolerance) {
            target = positions[j];
            break;
          }
        }
      }

      if (target !== null) {
        scrollToPosition(target);
      } else if (shouldLoop) {
        scrollToPosition(direction > 0 ? 0 : maximum);
      }
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    function clearPendingTarget() {
      pendingTarget = null;
    }

    /* User-driven scrolling takes over from any destination requested by an
       earlier arrow tap. `scrollend` is the clean reset after browser-driven
       smooth scrolling; pointer/touch/wheel cover browsers without it. */
    track.addEventListener('scrollend', clearPendingTarget);
    track.addEventListener('pointerdown', clearPendingTarget, { passive: true });
    track.addEventListener('wheel', clearPendingTarget, { passive: true });

    /* Native momentum scrolling handles ordinary swipes best on phones. At
       either hard edge there is nowhere for it to go, though, so remember
       where the gesture began and wrap only an outward swipe from that edge.
       This avoids hijacking a normal swipe which merely lands on the last
       card. */
    if (shouldLoop) {
      var touchStartX = null;
      var touchStartedAtStart = false;
      var touchStartedAtEnd = false;

      function resetTouch() {
        touchStartX = null;
        touchStartedAtStart = false;
        touchStartedAtEnd = false;
      }

      track.addEventListener('touchstart', function (event) {
        clearPendingTarget();
        if (!event.touches || event.touches.length !== 1) {
          resetTouch();
          return;
        }
        var maximum = maxScrollLeft();
        touchStartX = event.touches[0].clientX;
        touchStartedAtStart = track.scrollLeft <= edgeTolerance;
        touchStartedAtEnd = track.scrollLeft >= maximum - edgeTolerance;
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) {
          resetTouch();
          return;
        }
        var distance = event.changedTouches[0].clientX - touchStartX;
        if (touchStartedAtEnd && distance < -40) {
          scrollToPosition(0);
        } else if (touchStartedAtStart && distance > 40) {
          scrollToPosition(maxScrollLeft());
        }
        resetTouch();
      }, { passive: true });

      track.addEventListener('touchcancel', resetTouch, { passive: true });
    }
  }

  /* click-to-play inline video cards */
  function initVideoCards(root) {
    root.querySelectorAll('[data-mpdp-video-card]').forEach(function (card) {
      if (card.dataset.mpdpInit === 'true') return;
      card.dataset.mpdpInit = 'true';
      var video = card.querySelector('video');
      if (!video) return;
      card.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          video.setAttribute('controls', 'controls');
          card.classList.add('is-playing');
          /* permanent: the custom thumbnail must not return over a paused video */
          card.classList.add('has-played');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
    });
  }

  function initCtaScroll(root) {
    root.querySelectorAll('[data-mpdp-scroll-buybox]').forEach(function (btn) {
      if (btn.dataset.mpdpInit === 'true') return;
      btn.dataset.mpdpInit = 'true';
      btn.addEventListener('click', function () {
        var buybox = document.querySelector('[data-master-buybox]');
        if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* "See all reviews" and friends: smooth-scroll to a [data-anchor] section
       with the same header clearance the section nav uses. The href is a
       plain fragment, so with JS off the browser still jumps there. */
    root.querySelectorAll('[data-mpdp-scroll-anchor]').forEach(function (link) {
      if (link.dataset.mpdpInit === 'true') return;
      link.dataset.mpdpInit = 'true';
      link.addEventListener('click', function (event) {
        var target = anchorScrollTarget(link.dataset.mpdpScrollAnchor);
        if (!target) return;
        event.preventDefault();
        var y = target.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* The theme header is position:sticky (56px) but translates -56px on
     scroll-down and returns on scroll-up. Anything of ours that sticks must
     follow its live bottom edge, otherwise it floats with a gap when the
     header is hidden. Publishes --mpdp-sticky-top on <html>. */
  function trackHeaderOffset() {
    /* the header group also contains the announcement bar and pill tray, both
       zero-height — resolve the section that actually wraps <header> */
    var headerEl = document.querySelector('header');
    var header = headerEl && (headerEl.closest('.shopify-section') || headerEl);
    if (!header) return;
    var root = document.documentElement;
    var last = -1;
    var ticking = false;
    function update() {
      ticking = false;
      var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      if (bottom !== last) {
        last = bottom;
        root.style.setProperty('--mpdp-sticky-top', bottom + 'px');
      }
    }
    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    /* keep tracking while the header animates in/out */
    header.addEventListener('transitionend', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(header);
  }

  /* ------------------------------------------------------------------ */
  /* Sticky add-to-cart bar (snippets/master-pdp-sticky-atc.liquid)       */
  /* ------------------------------------------------------------------ */

  /* The bar mirrors the buy box; it never computes anything. Labels and
     prices are read off the plan cards as rendered, the add button clicks the
     buy box's own add button, and selection goes through the buy box's
     masterSelectPlan so variant, selling plan and gift stamp stay single
     sourced. */
  /* Click-away and Escape close the chooser. Bound to the document ONCE for
     the page, not per bar: init() re-runs on shopify:section:load, and in the
     theme editor that replaces the bar element — a per-bar binding would stack
     up a new pair of document listeners on every reload the merchant triggers.
     The handler reads the DOM afresh, so it keeps working on the new bar. */
  var stickyDismissBound = false;
  function bindStickyDismiss() {
    if (stickyDismissBound) return;
    stickyDismissBound = true;

    function closeAll() {
      document.querySelectorAll('[data-mpdp-sticky-options]').forEach(function (list) {
        list.hidden = true;
        var select = list.closest('[data-mpdp-sticky-select]');
        var toggle = select && select.querySelector('[data-mpdp-sticky-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-mpdp-sticky-select]')) closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  function initStickyAtc(bar) {
    if (bar.dataset.stickyInit === 'true') return;

    var widget = document.querySelector('[data-master-buybox]');
    var addBtn = widget && widget.querySelector('.master-buybox__atc-btn');
    /* No buy box on the page means nothing to mirror, and a bar that cannot
       add to cart is worse than no bar — leave it hidden. */
    if (!widget || !addBtn) return;
    bar.dataset.stickyInit = 'true';

    var toggle = bar.querySelector('[data-mpdp-sticky-toggle]');
    var optionList = bar.querySelector('[data-mpdp-sticky-options]');
    var labelEl = bar.querySelector('[data-mpdp-sticky-label]');
    var metaEl = bar.querySelector('[data-mpdp-sticky-meta]');
    var priceEl = bar.querySelector('[data-mpdp-sticky-price]');
    var btnLabelEl = bar.querySelector('[data-mpdp-sticky-btn-label]');
    var imageEl = bar.querySelector('.mpdp-sticky-atc__image');
    var stickyAdd = bar.querySelector('[data-mpdp-sticky-add]');
    var plans = Array.prototype.slice.call(widget.querySelectorAll('[data-master-plan]'));
    if (!plans.length) return;

    function text(el) {
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    /* The one-time option is a bare button carrying its whole label as text
       ("One-Time Purchase | £16.00"), not the card's label/pill/per-day parts,
       so every read falls back to the element's own text. */
    function planLabel(plan) {
      var label = text(plan.querySelector('.master-buybox__plan-label'));
      if (!label) return text(plan);
      var save = text(plan.querySelector('.master-buybox__save-pill'));
      return save ? label + ' (' + save + ')' : label;
    }

    function planMeta(plan) {
      return text(plan.querySelector('.master-buybox__per-day'));
    }

    /* The image the gallery is actually showing, which is the only honest
       source for it. The first slide varies by REGION (pdp_plan carries
       gallery_override plus gallery_override_eu / _us, resolved on the server
       by mpdp-region.liquid — a UK visitor is sent DEE-SLEEP-3-MONTH-UK.jpg
       and nothing else) and by the SELECTED PLAN. Reading the rendered
       gallery gets both for nothing; re-deriving them here would mean a second
       copy of the region table and the override fallbacks, free to drift from
       the picture on screen.

       A hidden slide still holds the 1x1 placeholder its src was swapped for,
       so those are skipped and the deferred URL preferred — on a plan change
       the gallery hydrates the revealed slide before announcing itself, but
       reading data-defer-src first means the order does not have to hold. */
    function galleryImageSrc() {
      var root = document.querySelector('.pdp-master-atf');
      if (!root) return '';
      var slides = root.querySelectorAll('.product-slideshow__item');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].hidden) continue;
        var img = slides[i].querySelector('img');
        if (!img) continue;
        var src =
          img.getAttribute('data-defer-src') || img.currentSrc || img.getAttribute('src') || '';
        if (!src || src.indexOf('data:') === 0) continue;
        return src;
      }
      return '';
    }

    function syncImage() {
      if (!imageEl) return;
      var src = galleryImageSrc();
      if (!src) return;

      /* The gallery's own copy is a full-width render and this thumbnail is
         56px, so ask the CDN for a small one rather than paying for the big
         file twice. */
      try {
        var url = new URL(src, window.location.href);
        url.searchParams.set('width', '160');
        src = url.href;
      } catch (e) {
        /* not a URL we can rewrite — use it as it came */
      }

      if (imageEl.getAttribute('src') === src) return;
      imageEl.setAttribute('src', src);
      /* The srcset Liquid rendered still describes the OLD image and would
         win over the new src at every width. */
      imageEl.removeAttribute('srcset');
      imageEl.removeAttribute('sizes');
    }

    function selectedPlan() {
      return (
        plans.filter(function (p) {
          return p.classList.contains('is-selected');
        })[0] || plans[0]
      );
    }

    function closeOptions() {
      optionList.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    /* Whatever the real button is doing: disabled (sold out, or mid-request)
       and `loading`, which is the class the theme's add-to-cart component puts
       on its own button for the length of the request. Mirroring it is what
       makes the spinner honest — the bar never starts or stops a spinner on a
       guess, so a failed or cancelled add cannot leave one turning forever. */
    function syncButtonState() {
      var busy = addBtn.classList.contains('loading');
      stickyAdd.disabled = addBtn.disabled;
      stickyAdd.classList.toggle('is-loading', busy);
      if (busy) {
        stickyAdd.setAttribute('aria-busy', 'true');
      } else {
        stickyAdd.removeAttribute('aria-busy');
      }
    }

    /* The theme flips those attributes on its own button, so watch them there.
       Nothing else tells this bar that a request has started or finished. */
    if (window.MutationObserver) {
      new MutationObserver(syncButtonState).observe(addBtn, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled']
      });
    }

    /* Whatever the real button says, including "Sold Out" and its disabled
       state — a sticky button that stays clickable on a sold-out variant just
       silently does nothing. */
    function syncFromBuybox() {
      var plan = selectedPlan();
      if (!plan) return;
      labelEl.textContent = planLabel(plan);
      metaEl.textContent = planMeta(plan);
      metaEl.hidden = metaEl.textContent === '';

      var atcPrice = widget.querySelector('[data-master-atc-price]');
      priceEl.textContent = atcPrice ? atcPrice.textContent : '';
      syncImage();

      var srcLabel = addBtn.querySelector('.js-product-form-submit-btn-text');
      if (srcLabel) btnLabelEl.textContent = text(srcLabel);
      syncButtonState();

      Array.prototype.forEach.call(optionList.children, function (li) {
        var isSelected = li.planRef === plan;
        li.classList.toggle('is-selected', isSelected);
        li.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    plans.forEach(function (plan) {
      var li = document.createElement('li');
      li.className = 'mpdp-sticky-atc__option';
      li.setAttribute('role', 'option');
      li.tabIndex = 0;
      li.textContent = planLabel(plan);
      li.planRef = plan;
      function choose() {
        /* fromUser is deliberately false: true smooth-scrolls the page back up
           to the buy box, which is the one thing someone using this bar is
           trying to avoid. */
        if (typeof widget.masterSelectPlan === 'function') {
          widget.masterSelectPlan(plan, false);
        } else {
          plan.click();
        }
        closeOptions();
        toggle.focus();
      }
      li.addEventListener('click', choose);
      li.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose();
        }
      });
      optionList.appendChild(li);
    });

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var open = optionList.hidden;
      optionList.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    bindStickyDismiss();

    stickyAdd.addEventListener('click', function () {
      /* A click on the real button, not a bare form submit: the theme's handler
         reads the submitter, and that button carries the spinner and the error
         wiring. */
      addBtn.click();
    });

    widget.addEventListener('master:plan-changed', syncFromBuybox);
    syncFromBuybox();

    /* Always on. The bar is part of the page rather than something that comes
       and goes with the buy box — no rect watching, no scroll listener, no
       timer; it is shown once and stays.

       The `hidden` attribute is dropped here and visibility handed to a class,
       because display:none cannot be transitioned. Dropped only now, on init,
       so a page whose script never runs still shows no bar.

       One frame between becoming displayable and the class, so the opening
       state has been painted and the bar slides in rather than appearing in
       place: set in the same frame there is no start value to transition from
       and it snaps. */
    bar.hidden = false;
    window.requestAnimationFrame(function () {
      bar.classList.add('is-visible');
    });
  }

  function init() {
    trackHeaderOffset();
    document.querySelectorAll('[data-master-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-mpdp-sticky-atc]').forEach(initStickyAtc);
    document.querySelectorAll('[data-mpdp-nav]').forEach(initSectionNav);
    document.querySelectorAll('[data-mpdp-carousel]').forEach(initScrollCarousel);
    document.querySelectorAll('.pdp-master-atf').forEach(function (root) {
      initGalleryProgress(root);
      neutralizeGalleryHeight(root);
      initVideoCards(root);
      initCtaScroll(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
